import React, { useState, useRef, useEffect } from 'react';
import { CalciteBlock } from '@esri/calcite-components-react';
import config from '../../assets/config.json';
// import styles from './LayersAndLegend.module.scss';
import LayerList from '@arcgis/core/widgets/LayerList';
// import esriRequest from "@arcgis/core/request";

const LayersAndLegend = (props) => {
  const [layerList /* , setLayerList */] = useState(new LayerList({
    view: props.view,
    listItemCreatedFunction: async (event) => {
      const item = event.item;
      if (item.layer.type !== 'tile' &&
          item.layer.parent !== props.webmap.layers.find(l => l.title === 'Tribal') &&
          item.layer.parent !== props.webmap.layers.find(l => l.title === 'Impaired Waters') &&
          !item.layer.layers) {
        item.panel = {
          content: 'legend',
          open: true,
        };
      } 
      if (config.layersToExcludeInList.find(layerTitle => layerTitle === item.layer.title)) {
        item.layer.listMode = 'hide';
      }
    }
  }));

const layerLegendDiv = useRef(null);

  useEffect(() => {
    if (layerLegendDiv.current) {
      layerList.container = layerLegendDiv.current;
    }
  });


  return (
    <div >
      <CalciteBlock heading='Layers and Legend' description='Toggle layer visibility to view its legend' collapsible open>
        <div ref={layerLegendDiv}>
        </div>
      </CalciteBlock>
    </div>
  );

}

export default LayersAndLegend;
